import React from "react";

import { templates } from "@reactivated";

import { CreateAccount } from "../apps/checkout/CreateAccount";
import { isoWebPageURL } from "../models/nominals";

export const Template = (
    props: templates.CreateAccountTemplate,
): React.JSX.Element => {
    return (
        <CreateAccount
            firstName={props.first_name}
            email={props.email}
            isAuthenticatedAsOrderOwner={props.is_authenticated_as_order_owner}
            orderOwnerHasPassword={props.order_owner_has_password}
            orderHistoryURL={isoWebPageURL.wrap(props.order_history_url)}
        />
    );
};
